<template>
    <div class="side-nav-item" :class="{ 'side-nav-item--selected': selected }">
        <div class="side-nav-item__title">
            {{ title }}
        </div>
        <div class="side-nav-item__category">
            {{ category }}
        </div>
        <div class="side-nav-item__sub-category">
            <template v-if="Array.isArray(subCategory)">
                <span v-for="(subCategoryItem, index) in subCategory" :key="index">
                    {{ subCategoryItem }}
                </span>
            </template>
            <template v-else>
                {{ subCategory }}
            </template>
        </div>
        <div v-if="attribute == LS_POINT" class="side-nav-item__attribute">
            <img src="/images/icons/lspoint.svg" alt="LS Point">
        </div>
    </div>
</template>

<script>
import {LS_POINT} from "../../const";
export default {
    name: 'SideNavTenantItem',
    props: {
        title: String,
        category: String,
        subCategory: String | Array,
        attribute: Number,
        selected: Boolean
    },
    data() {
        return {
            LS_POINT
        }
    }
}
</script>
